module.exports = __webpack_public_path__ + "static/media/5D.8a323d2d.svg";